import { getApiKey } from "../utils/apiKey";
import { apiCall_domain, token } from "../Component/api";
import axios from "axios";
export const getEmergencyIndex = () => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.get(`${apiCall_domain}/customer/emergency/index`, { headers });
};
export const getEmergencyServices = () => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.get(`${apiCall_domain}/customer/emergency/services`, {
    headers,
  });
};
export const submitServiceRequest = (data) => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.post(
    `${apiCall_domain}/customer/emergency/createRequest`,
    data,
    {
      headers,
    }
  );
};
export const getCars = () => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.get(`${apiCall_domain}/customer/user/cars`, {
    headers,
  });
};
export const getserviceHistory = () => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.get(`${apiCall_domain}/customer/emergency/history`, {
    headers,
  });
};
export const getServiceHisotryDetail = (id) => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.get(
    `${apiCall_domain}/customer/emergency/history/details?order_id=${id}`,
    {
      headers,
    }
  );
};

export const getShifts = (id, type) => {
  const headers = {
    Authorization: getApiKey() || token(),
    "content-type": "application/json",
  };
  return axios.get(
    `${apiCall_domain}/customer/mechanics/${id}/shifts?type=${type}`,
    {
      headers,
    }
  );
};
